<template>
    <div>
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" class="form_box">
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-textarea  :rows="4" v-model="form.name"  :maxLength=200
                             @change="(e) => { formErr.name=''}"
                             @blur="(e) => {  form.name = e.target.value.trim() }"/>

            </a-form-model-item>
          <a-form-model-item
              ref="activity_cover"
              label="封面"
              prop="activity_cover"

              :validateStatus='!formErr.activity_cover||formErr.activity_cover==""?"":"error"'
              class="ant-form-item-requireds "
          >
          <Myupload :url="form.activity_cover||''"  @fileList="setFileList"/>
          </a-form-model-item>
<!--          <a-form-model-item-->
<!--              ref="activity_cover"-->
<!--              label="封面"-->
<!--              prop="activity_cover"-->
<!--              :extra="formErr.activity_cover"-->
<!--              :validateStatus='!formErr.activity_cover||formErr.activity_cover==""?"":"error"'-->
<!--          >-->
<!--            <a-upload-->
<!--                :action="this.$store.state.urlChang"-->
<!--                :data="{type:4}"-->
<!--                :file-list="fileList"-->
<!--                :headers="headers"-->
<!--                @change="(file)=>{handleChange(file)}"-->
<!--                :before-upload="beforeUpload"-->
<!--                @preview="handlePreview"-->
<!--                list-type="picture-card"-->
<!--                name="file"-->
<!--            >-->
<!--              <div v-if="fileList.length < 1">-->
<!--                <a-icon type="plus" style="font-size: 40px;color:#a9a9a9"/>-->
<!--&lt;!&ndash;                <div class="ant-upload-text">Upload</div>&ndash;&gt;-->
<!--              </div>-->
<!--            </a-upload>-->
<!--            <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">-->
<!--              <img :src="previewImage" alt="example" style="width: 100%"/>-->
<!--            </a-modal>-->
<!--            <span>建议：图片尺寸800px X 452px，图片质量大小不超过200KB</span>-->
<!--          </a-form-model-item>-->
          <a-form-model-item
              ref="activity_url"
              label="链接"
              prop="activity_url"
              :help="formErr.activity_url"
              :validateStatus='!formErr.activity_url||formErr.activity_url==""?"":"error"'
          >
            <a-input  :rows="4" v-model="form.activity_url"  :maxLength=200
                         @change="(e) => { formErr.activity_url=''}"
                         @blur="(e) => {  form.activity_url = e.target.value.trim() }"/>

          </a-form-model-item>
          <a-form-model-item
              ref="site_types"
              label="推送网站类型"
              prop="site_types"
              :help="formErr.site_types"
              :validateStatus='!formErr.site_types||formErr.site_types==""?"":"error"'
          >
            <a-checkbox-group v-model="form.site_types" :value="form.site_types"  >
                <span v-for="(item,index) in this.seleList.site_type" style="display: inline-block;margin-right: 8px" >
                 <a-checkbox :value="item.value"> </a-checkbox>
                <span style="max-width: 200px;overflow: hidden;display: inline-block;height:20px;position: relative;top: 2px;padding-left: 5px; " class="sef1" :title="item.name">{{item.name}}</span>
                </span>
            </a-checkbox-group>

          </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="item in this.seleList.activity_status"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item v-if="form.status==1"
                    ref="validity_time"
                    label="有效期"
                    prop="validity_time"
                    :help="formErr.validity_time"
                    :validateStatus='!formErr.validity_time||formErr.validity_time==""?"":"error"'
            >
<!--              :show-time="{ format: 'HH:mm:ss' }"-->
                <a-range-picker
                    :showTime="false"
                        v-model="form.validity_time"
                    :show-time="false"
                        format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="is_popup"
                    label="显示"
                    prop="is_popup"
                    :extra="formErr.is_popup"
                    :validateStatus='!formErr.is_popup||formErr.is_popup==""?"":"error"'
            >
                <a-switch   defaultChecked v-model="form.is_popup" />
                <span>客户后台是否弹窗显示</span>
            </a-form-model-item>
            <a-form-model-item>
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            取消
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>

    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"
    // import ckeditor4 from '../../Components/ckeditors'
    import Myupload from '../../Components/my-upload/index.vue'
    import API from "../api";
    import moment from 'moment';
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "newForm",

        data() {
            return {
              headers: {Authorization: window.sessionStorage.getItem("signature")},

              fileList:[],
              previewVisible: false,
              previewImage: "",
                cknum:0,
                id: this.$route.query.id,
                contenta: "",
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                seleList:[],
                drawerConfig:drawerConfig,
                form: {
                  activity_cover:"",
                  site_types:[],
                    name:"",
                    status:1,
                    validity_time:null,
                    is_popup:true,activity_url:""
                },
                formErr: {
                  activity_cover:"",
                  site_types:"",
                    name:"",
                    status:"",
                    validity_time:"",
                    is_popup:"",activity_url:""
                },
                rules: {
                  activity_cover:[{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.activity_cover)}  , trigger: "blur"  },],
                  activity_url: [{required: true, message: "请输入链接",  },{type: 'url' , message: "请输入有效链接",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.activity_url)}  , trigger: "blur"  },],
                  site_types:[{required: true, message: "请至少选择一个推送类型",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.site_types)}  , trigger: "blur"  },],
                  name: [{required: true, message: "请输入标题 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    // content:[{required: true, message: "请输入内容 ",trigger:['change', 'blur']  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.content)}  , trigger:["blur","change"]   },],
                  validity_time: [{required: true, message: "请输入有效期",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.validity_time)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span:14 },
                },
            };

        },
      components:{Myupload},
        created() {
            this.$store.state.adminleftnavnum = "/HotEvents/HotEventsList"; //设置左侧导航2-2 active
        },
        mounted(){
            let _that=this
            this.$nextTick().then(function () {
                _that.getFormData()
            })
        },
        computed: {
            deforDate: function () {
                return moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }
        },
        methods: {
          //
          setFileList(url){
            this.fileList ={ id: '1',name: url,url: url}
            this.formErr.activity_cover=""
            if(url!=""){
              this.$refs.ruleForm.clearValidate('activity_cover', (contentError) => {  })
            }else{
              this.$refs.ruleForm.validateField('activity_cover', (contentError) => {  })
            }

            },
    handleCancel() {
            this.previewVisible = false;
          },
          handleChange(info ) {
            let {fileList} = info;
            const status = info.file.status;

            if (status !== 'uploading') {
              this.fileList=[]
            }
            if (status === 'done') {
              this.formErr.activity_cover=""
              this.fileList= fileList
            } else if (status === 'error') {
            }
            if (status === 'uploading') {
              this.fileList= fileList
            }
            if (status=== 'done') {
              getBase64(info.file.originFileObj, imageUrl => {
                this.formErr.activity_cover=""
                this.fileList= fileList
              });
            }
            //重新设置state
            // this.setState( {fileList});
          },
          beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
              this.$message.error('只能上传jpeg,jpg，png类型图片!');
              return false
            }

            const isLt2M = file.size < 204800;
            if (!isLt2M) {
              this.$message.error('图片必须小于 200kb!');
              return false
            }
            return new Promise(function (resolve,reject) {
              resolve(file)
            })
          },
          async handlePreview(file) {
            if (!file.url && !file.preview) {
              file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
          },

            onClose(){
                this.$router.push({path: '/HotEvents/HotEventsList'})
            },
            editform(id){
                API.service.EDIT_DATA(id).then(res => {
                    let data=res.data.data.info
                    data.is_popup==0?data.is_popup=false:data.is_popup=true
                    data.status= data.status
                  data.site_types=data.site_types.split(",").length>1?data.site_types.split(",").map(Number):[data.site_types].map(Number)

                    if(data.status==1){
                        data.validity_time=[moment(res.data.data.info.start_time_format,  'YYYY-MM-DD HH:mm:ss'), moment(res.data.data.info.end_time_format, 'YYYY-MM-DD HH:mm:SS')]
                    }else{
                        data.validity_time=null
                    }
                  if (data.activity_cover == "") {
                    this.fileList = []
                  } else {
                    // this.activity_cover
                    this.fileList ={ id:data.activity_cover,name:data.activity_cover,url:data.activity_cover ? data.activity_cover : ""}
                  }
                  this.form.id=this.id
                    this.form = data
                    let _that=this
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.contenta = data.content_text
                    //     }, 800)
                    // })
                    this.form.id=id
                })
            },
            // ckeditorContent(val) {
            //     this.form.content = val
            //     this.$refs.ruleForm.validateField('content', (contentError) => {
            //         if(!phoneError){
            //             //当校验通过时，这里面写逻辑代码
            //             this.formErr.content=""
            //         }
            //     })
            // },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                  // this.cListList=res.data.data
                    let _that=this
                  if(_that.id!=undefined){ _that.editform(_that.id)}
                    // this.$nextTick().then(function () {
                    //     if(_that.id!=undefined){ _that.editform(_that.id)}
                    // })
                    // if(this.id!=undefined){ this.editform(this.id)}
                })
            },
            onSubmit() {
              let _this = this;
              if (!this.fileList.url||this.fileList.url=="") {
                _this.formErr.activity_cover = "请上传封面图";

              }
              // else {
              //   _this.formErr.activity_cover = "";
              //   this.form.activity_cover = this.fileList.url
              // }
              // if (this.fileList.length > 0 && this.fileList.url) {
              //   this.form.activity_cover = this.fileList.url
              // } else {
              //   this.form.activity_cover = ""
              // }

                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.is_popup==true?subData.is_popup=1:subData.is_popup=0
                        // subData.content_text=subData.content
                       if(subData.validity_time!=null&&subData.validity_time&&subData.validity_time.length>0) {
                           subData.validity_time[0]=moment(subData.validity_time[0]).format('YYYY-MM-DD HH:mm:ss')
                           subData.validity_time[1]=moment(subData.validity_time[1]).format('YYYY-MM-DD HH:mm:ss')
                       }
                      subData.site_types=subData.site_types.toString()
                      subData.activity_cover=this.fileList.url;
                        // subData.release_time!=""?subData.release_time=moment(subData.release_time).format('YYYY-MM-DD HH:mm:SS'): subData.release_time=null
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                setTimeout(() => {
                                    this.onClose()
                                }, 1500)
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.form_box>>>.has-error .ant-form-extra{bottom: 0!important;}
.form_box>>>.ant-form-explain{margin-bottom: unset!important;}
.form_box>>>.ant-form-explain, .ant-form-extra{margin-top: unset!important;}
.form_box>>>form .ant-mentions, form textarea.ant-input{margin-bottom: unset!important;}
.ant-form-item-requireds >>> .ant-form-item-label::before{
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}

</style>
